import { FunctionalType } from './blockedFunctionalType';
import { ServiceFeatures } from './serviceFeatures';

export type BlockedFunctionalSettings = {
	feature: ServiceFeatures;
	title: string;
	mediaUrl: string;
	description: string;
}

export const TYPES_SETTINGS: { [key in FunctionalType]: BlockedFunctionalSettings } = {
	[FunctionalType.Analytics]: {
		feature: ServiceFeatures.Analytics,
		title: 'ANALYTICS',
		mediaUrl: '/static/gif/blocked-functional/analytics.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.ANALYTICS'
	},
	[FunctionalType.Control]: {
		feature: ServiceFeatures.ExecutionControl,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.CONTROL',
		mediaUrl: '/static/gif/blocked-functional/control.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.CONTROL'
	},
	[FunctionalType.Blocks]: {
		feature: ServiceFeatures.PlanogramBlocks,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.BLOCKS',
		mediaUrl: '/static/gif/blocked-functional/blocks.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.BLOCKS'
	},
	[FunctionalType.PlansCompare]: {
		feature: ServiceFeatures.PlansComparison,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PLANS_COMPARE',
		mediaUrl: '/static/gif/blocked-functional/plansCompare.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.STORE_PLANS_COMPARISON'
	},
	[FunctionalType.ProductsHighlightsControl]: {
		feature: ServiceFeatures.ProductsHighlight,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PRODUCTS_HIGHLIGHTS',
		mediaUrl: '/static/gif/blocked-functional/highlightProductsView.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PRODUCTS_HIGHLIGHT'
	},
	[FunctionalType.ProductsHighlightsPlanogramView]: {
		feature: ServiceFeatures.ProductsHighlight,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PRODUCTS_HIGHLIGHTS',
		mediaUrl: '/static/gif/blocked-functional/highlightProductsView.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PRODUCTS_HIGHLIGHT'
	},
	[FunctionalType.ProductsHighlightsPlanogramEdit]: {
		feature: ServiceFeatures.ProductsHighlight,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PRODUCTS_HIGHLIGHTS',
		mediaUrl: '/static/gif/blocked-functional/highlightProductsEdit.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PRODUCTS_HIGHLIGHT'
	},
	[FunctionalType.ReversedLayout]: {
		feature: ServiceFeatures.LayoutReverse,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.REVERSED_LAYOUT',
		mediaUrl: '/static/gif/blocked-functional/reversedLayout.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.REVERSED_LAYOUT'
	},
	[FunctionalType.Rotation]: {
		feature: ServiceFeatures.ProductsRotation,
		title: 'PRODUCT_ROTATION',
		mediaUrl: '/static/gif/blocked-functional/productsRotation.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PRODUCTS_ROTATION'
	},
	[FunctionalType.SendExecution]: {
		feature: ServiceFeatures.PlanogramsExecution,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.SEND_EXECUTION',
		mediaUrl: '/static/gif/blocked-functional/sendExecution.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.EXECUTION'
	},
	[FunctionalType.PlanogramCopying]: {
		feature: ServiceFeatures.PlanogramCopy,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PLANOGRAM_COPYING',
		mediaUrl: '/static/gif/blocked-functional/planogramsCopying.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PLANOGRAM_COPYING'
	},
	[FunctionalType.PlanogramExtendedCopying]: {
		feature: ServiceFeatures.PlanogramExtendedCopy,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PLANOGRAM_COPYING',
		mediaUrl: '/static/gif/blocked-functional/planogramsCopying.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PLANOGRAM_COPYING'
	},
	[FunctionalType.RevertPlanogram]: {
		feature: ServiceFeatures.PlanogramRevert,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PLANOGRAM_REVERT',
		mediaUrl: 'static/gif/blocked-functional/revertPlanogram.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PLANOGRAM_REVERT'
	},
	[FunctionalType.PlanogramHistory]: {
		feature: ServiceFeatures.PlanogramsExecution,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PLANOGRAM_HISTORY',
		mediaUrl: '/static/gif/blocked-functional/planogramHistory.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PLANOGRAM_HISTORY'
	},
	[FunctionalType.PlanogramsCompare]: {
		feature: ServiceFeatures.PlanogramsComparison,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PLANOGRAMS_COMPARE',
		mediaUrl: '/static/gif/blocked-functional/planogramsCompare.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PLANOGRAMS_COMPARISON'
	},
	[FunctionalType.PlanAnalytics]: {
		feature: ServiceFeatures.Analytics,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PLAN_ANALYTICS',
		mediaUrl: '/static/gif/blocked-functional/planAnalytics.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.STORE_PLAN_ANALYTICS'
	},
	[FunctionalType.PlanogramAnalytics]: {
		feature: ServiceFeatures.Analytics,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PLANOGRAM_ANALYTICS',
		mediaUrl: '/static/gif/blocked-functional/planogramAnalytics.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PLANOGRAM_ANALYTICS'
	},
	[FunctionalType.MasterPositions]: {
		feature: ServiceFeatures.MasterPositions,
		title: 'MASTER_POSITION.TITLE',
		mediaUrl: '/static/img/expanding_opportunities/master_position_en.png',
		description: 'DEMO.BLOCKED_FUNCTIONAL.MASTER_POSITION'
	},
	[FunctionalType.ArchiveProducts]: {
		feature: ServiceFeatures.ProductsArchive,
		title: 'COMMON.PRODUCT.ARCHIVED_PRODUCTS',
		mediaUrl: '/static/gif/blocked-functional/archiveProducts.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.ARCHIVE_PRODUCTS'
	},
	[FunctionalType.PlanogramGroups]: {
		feature: ServiceFeatures.PlanogramGroups,
		title: 'DEMO.BLOCKED_FUNCTIONAL.TITLES.PLANOGRAM_GROUPS',
		mediaUrl: '/static/gif/blocked-functional/planogramGroup.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.PLANOGRAM_GROUPS'
	},
	[FunctionalType.StorePlans]: {
		feature: ServiceFeatures.StorePlans,
		title: 'COMMON.ENTITY.STORE_PLANS',
		mediaUrl: '/static/gif/blocked-functional/storePlans.gif',
		description: 'DEMO.BLOCKED_FUNCTIONAL.STORE_PLANS'
	}
};